import joi from 'joi';
import joiPhoneNumber from 'joi-phone-number';
import listAlpha from '../utils/ianaList';

var helper = {
  isValidPhoneNumber(phonenum: string, country: string) {
    const customizedJoi = joi.extend(joiPhoneNumber);
    const validator = customizedJoi
      .string()
      .phoneNumber({ defaultCountry: country, strict: true })
      .validate(phonenum);
    return !validator.error;
  },
  isNumeric(num: string) {
    const result: any = num.replace(/[.,\s]/g, '');
    return !isNaN(result);
  },
  isAlphabetic(text: string) {
    const letters = /^[a-zA-Z\s]*$/;
    return letters.test(text);
  },
  isDecimal(text: string) {
    const dec = /^[0-9]*\.?[0-9]*$/;
    return dec.test(text);
  },
  isEmail(email: string) {
    const schema = joi.string().email({ tlds: { allow: listAlpha } });
    const validator = schema.validate(email);
    return !validator.error;
  },
  isEmptyObject(obj: any) {
    return [Object, Array].includes((obj || {}).constructor) && !Object.entries(obj || {}).length;
  }
};
export default helper;
